import { useState, useEffect, useRef } from 'react';

const useInactivity = (timeout = 5 * 60 * 1000) => {
    const [isInactive, setIsInactive] = useState(false);
    const [isTabInactive, setIsTabInactive] = useState(false);
    const timeoutRef = useRef(null);
    const lastActivityRef = useRef(Date.now());

    const resetTimeout = () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            if (Date.now() - lastActivityRef.current >= timeout) {
                setIsInactive(true);
            }
        }, timeout);
    };

    const handleActivity = () => {
        lastActivityRef.current = Date.now();
        setIsInactive(false);
        resetTimeout();
    };

    const handleVisibilityChange = () => {
        if (document.hidden) {
            setIsTabInactive(true);
        } else {
            setIsTabInactive(false);
        }
    };

    useEffect(() => {
        const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];
        events.forEach((event) => document.addEventListener(event, handleActivity));
        document.addEventListener('visibilitychange', handleVisibilityChange);

        resetTimeout();

        return () => {
            events.forEach((event) => document.removeEventListener(event, handleActivity));
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            clearTimeout(timeoutRef.current);
        };
    }, [timeout]);

    return { isInactive, isTabInactive };
};

export default useInactivity;